module.exports = __webpack_public_path__ + "static/fonts/BMKkubulimTTF.ttf?b0943a50";